import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticleCompleteGuide from "../pages/article/allchinabuy-spreadsheet-complete-guide/page";
import ArticleSneakers from "../pages/article/how-to-find-best-sneakers-allchinabuy-spreadsheet/page";
import ArticleSafety from "../pages/article/allchinabuy-spreadsheet-safety-tips/page";
import ArticleBrands from "../pages/article/top-designer-brands-allchinabuy-spreadsheet/page";
import ArticleShipping from "../pages/article/allchinabuy-spreadsheet-shipping-guide/page";
import ArticleBeginner from "../pages/article/beginner-first-purchase-allchinabuy-spreadsheet/page";
import ArticleQC from "../pages/article/qc-photos-guide-allchinabuy-spreadsheet/page";
import ArticleSeasonal from "../pages/article/seasonal-trending-finds-allchinabuy-spreadsheet/page";
import ArticleComparison from "../pages/article/spreadsheet-vs-manual-browsing-allchinabuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/article/allchinabuy-spreadsheet-complete-guide",
    element: <ArticleCompleteGuide />,
  },
  {
    path: "/article/how-to-find-best-sneakers-allchinabuy-spreadsheet",
    element: <ArticleSneakers />,
  },
  {
    path: "/article/allchinabuy-spreadsheet-safety-tips",
    element: <ArticleSafety />,
  },
  {
    path: "/article/top-designer-brands-allchinabuy-spreadsheet",
    element: <ArticleBrands />,
  },
  {
    path: "/article/allchinabuy-spreadsheet-shipping-guide",
    element: <ArticleShipping />,
  },
  {
    path: "/article/beginner-first-purchase-allchinabuy-spreadsheet",
    element: <ArticleBeginner />,
  },
  {
    path: "/article/qc-photos-guide-allchinabuy-spreadsheet",
    element: <ArticleQC />,
  },
  {
    path: "/article/seasonal-trending-finds-allchinabuy-spreadsheet",
    element: <ArticleSeasonal />,
  },
  {
    path: "/article/spreadsheet-vs-manual-browsing-allchinabuy",
    element: <ArticleComparison />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;